import styled from "styled-components";

export const Home = styled.div`
  height: 84vh;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const HomeImage = styled.img`
  width: 30%;
`;
export const TextAndButtons = styled.section`
  display: flex;
  width: 40%;
  height: 40%;
  flex-direction: column;
  justify-content: space-around;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
`;